import { useContext } from 'react';
import WaveSurferContext from '../contexts/WaveSurferContext.js';

function useWavesurferContext() {
    return useContext(WaveSurferContext);
}

export { useWavesurferContext as default };
